const SUPPRESSOR_CONFIG = {
  suppressedPatterns: [
    /Cannot read properties of undefined \(reading 'length'\)/,
    /TypeError.*mgid/,
    /jsc\.mgid\.com.*TypeError/,
    /ee\.worker.*mgid/,
    /mgid.*undefined/,
    /adsbygoogle.*no_div/,
    /adsbygoogle.*push.*error/,
    /Minified React error #418/,
  ],

  suppressedUrls: [
    'jsc.mgid.com',
    'mgid.com',
    'googlesyndication.com',
    'adsbygoogle.js',
  ],

  suppressedLogLevel: 'warn',
};

function shouldSuppressError(error, source) {
  const errorMessage = error?.message || error?.toString() || '';
  const isSuppressedPattern = SUPPRESSOR_CONFIG.suppressedPatterns.some((pattern) =>
    pattern.test(errorMessage)
  );

  const isSuppressedUrl =
    source && SUPPRESSOR_CONFIG.suppressedUrls.some((url) => source.includes(url));

  return isSuppressedPattern || isSuppressedUrl;
}

function suppressConsoleErrors() {
  if (typeof window === 'undefined') return;

  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;

  console.error = function (...args) {
    const error = args[0];
    const source = args[1]?.filename || '';

    if (shouldSuppressError(error, source)) {
      if (SUPPRESSOR_CONFIG.suppressedLogLevel === 'warn') {
        console.warn('[Suppressed Error]', ...args);
      }
      return;
    }

    originalConsoleError.apply(console, args);
  };

  console.warn = function (...args) {
    const message = args[0];
    const source = args[1]?.filename || '';

    if (shouldSuppressError(message, source)) {
      return;
    }

    originalConsoleWarn.apply(console, args);
  };
}

function suppressEventErrors() {
  if (typeof window === 'undefined') return;

  window.addEventListener(
    'error',
    (event) => {
      const errorMessage = event.message || event.error?.message || '';
      const filename = event.filename || event.error?.stack || '';

      if (shouldSuppressError({ message: errorMessage }, filename)) {
        event.preventDefault();
        return true;
      }
    },
    true
  );

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason?.message || event.reason?.toString() || '';
    const filename = event.reason?.stack || '';

    if (shouldSuppressError({ message: reason }, filename)) {
      event.preventDefault();
      return true;
    }
  });
}

function initializeErrorSuppressor() {
  if (typeof window === 'undefined') return;

  try {
    suppressConsoleErrors();
    suppressEventErrors();
  } catch {}
}

function restoreConsole() {
  if (typeof window === 'undefined') return;
}

export {
  initializeErrorSuppressor,
  restoreConsole,
  shouldSuppressError,
  SUPPRESSOR_CONFIG,
};
